export var reduxKey = '@@favouritedByModal';
//# sourceMappingURL=constants.js.map